import { apiPaths } from "../utils/apiUtils";
import qs from 'qs';
import api from "./api";

export async function getAnalytics(params) {
    try {
        console.log("Frontend: Sending request with params:", params);
        const response = await api.get(`${apiPaths.analytics}`, {
            params: { ...params },
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
        });

        if (!response || !response.data) {
            throw new Error("Invalid response structure");
        }

        return response?.data;
    } catch (error) {
        throw handleApiError(error, "Fetching Analytics Data");
    }
}

export async function getApplicationStatusChartData(params) {
    try {
        console.log("Frontend: Sending request with params:", params);
        const response = await api.get(`${apiPaths.analytics}/applicationStatusChartData`, {
            params: { ...params },
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
        });

        console.log("Response for Application Status Chart: ", response)

        if (!response || !response.data) {
            throw new Error("Invalid response structure");
        }

        return response?.data;
    } catch (error) {
        throw handleApiError(error, "Fetching Application Status Chart Data");
    }
}

export async function getDesktopVsMobileApplicationsData(params) {
    try {
        console.log("Frontend: Sending request with params:", params);
        const response = await api.get(`${apiPaths.analytics}/desktopVsMobileApplicationsData`, {
            params: { ...params },
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
        });

        console.log("Response for Application Status Chart: ", response)

        if (!response || !response.data) {
            throw new Error("Invalid response structure");
        }

        return response?.data;
    } catch (error) {
        throw handleApiError(error, "Fetching Desktop Vs Mobile Applications Data");
    }
}

export async function getAverageReviewTimeData(params) {
    try {
        console.log("Frontend: Sending request with params:", params);
        const response = await api.get(`${apiPaths.analytics}/averageReviewTimeData`, {
            params: { ...params },
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
        });

        console.log("Response for Application Average Review Time Chart: ", response)

        if (!response || !response.data) {
            throw new Error("Invalid response structure");
        }

        return response?.data;
    } catch (error) {
        throw handleApiError(error, "Fetching Average Review Time Data");
    }
}

export async function getDropOffData(params) {
    try {
        console.log("Frontend: Sending request with params:", params);
        const response = await api.get(`${apiPaths.analytics}/dropOffData`, {
            params: { ...params },
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
        });

        console.log("Response for Drop off Chart: ", response)

        if (!response || !response.data) {
            throw new Error("Invalid response structure");
        }

        return response?.data;
    } catch (error) {
        throw handleApiError(error, "Fetching Drop Off Data");
    }
}

/**
 * Centralized error handler for API calls.
 * @param {Error} error - The caught error.
 * @param {string} context - Context message for debugging.
 */
function handleApiError(error, context) {
    const status = error.response?.status;
    const errorData = error?.response?.data;
    const errorMessage = errorData?.message || error?.message;

    console.error(`[API Error]: ${context} - Status: ${status || "N/A"}, Message: ${errorMessage}`);
    return errorData || errorMessage;
}